export default __webpack_public_path__ + "static/media/Frame 605.9eb53c06.png";